import css from './cache.module.scss';

export function Cache() {
    return (
        <div className={css.cache}>
            <p className={css.label}>Cache</p>
            <p className={css.value}>Edge CDN</p>
            <p className={css.note}>1 hour TTL</p>
        </div>
    );
}
